

document.addEventListener('DOMContentLoaded', function(){
  const buy = document.querySelector('#buy');
  document.querySelectorAll('[data-scroll-buy]').forEach(btn => btn.addEventListener('click', () => buy && buy.scrollIntoView({behavior:'smooth', block:'start'})));
  document.querySelectorAll('[data-scroll-how]').forEach(btn => btn.addEventListener('click', () => { const el=document.querySelector('#how'); if(el) el.scrollIntoView({behavior:'smooth'}); }));
  const qty = document.querySelector('#qty');
  const minus = document.querySelector('[data-qty-minus]');
  const plus = document.querySelector('[data-qty-plus]');
  if(qty && minus && plus){
    minus.addEventListener('click', () => qty.value = Math.max(1, (parseInt(qty.value)||1)-1));
    plus.addEventListener('click', () => qty.value = Math.min(10, (parseInt(qty.value)||1)+1));
    qty.addEventListener('input', () => qty.value = String(Math.max(1, Math.min(10, parseInt(qty.value)||1))));
  }
  document.querySelectorAll('.swatch').forEach(swatch => swatch.addEventListener('click', () => {
    document.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');
    const selected=document.querySelector('#selectedColor'); if(selected) selected.textContent = swatch.dataset.color;
  }));
  document.querySelectorAll('.faq-question').forEach(button => button.addEventListener('click', () => button.parentElement.classList.toggle('open')));
});

